import { BasicTag } from "types/TagType";
import { IconThemeProps } from "hardcover-ui/theme/components/icon";
import Icon from "hardcover-ui/components/Icon";
import { tagIconMap } from "./constants";

interface Props {
  tag: BasicTag;
  size: IconThemeProps["size"];
}

function findIcon(tag: BasicTag) {
  return tagIconMap[tag.category.toLocaleLowerCase()]
    ? tagIconMap[tag.category.toLocaleLowerCase()][tag.tag.toLocaleLowerCase()]
    : null;
}

export default function TagIcon({ tag, size }: Props) {
  const icon = findIcon(tag);

  if (!icon) {
    return <></>;
  }

  return <Icon icon={icon} size={size} />;
}
